
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * 解答欄の入力用ボタン
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
  },
})
export default class ButtonInput extends Vue {
  /** アイコンのパス */
  @Prop()
  private iconPath!: string

  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
